/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//English (United Kingdom)
export default {
  'confluence-table-tree.column.contributors': 'Contributors',
  'confluence-table-tree.column.last-modified': 'Last modified',
  'confluence-table-tree.column.title': 'Name',
  'confluence-table-tree.could-not-load': "Couldn't load",
  'confluence-table-tree.could-not-load-contributors': "Couldn't load contributors",
  'confluence-table-tree.create-child-page': 'Create a child page',
  'confluence-table-tree.create-page': 'Create page',
  'confluence-table-tree.default.page.title': 'Untitled',
  'confluence-table-tree.default.show-all-pages-button.label': 'Show more pages',
  'confluence-table-tree.draft.lozenge': 'DRAFT',
  'confluence-table-tree.draft.tooltip': 'Drafts can only be seen by you.',
  'confluence-table-tree.drafts-toggle.label': 'Show drafts',
  'confluence-table-tree.edit': 'Edit',
  'confluence-table-tree.edit-in-confluence': 'Edit in Confluence',
  'confluence-table-tree.empty.description':
    'Create some meeting notes, product requirements, decisions, or other content to see this space fill up.',
  'confluence-table-tree.empty.title': "There's nothing here but potential",
  'confluence-table-tree.error.description': "We can't show you these pages. Please try again later.",
  'confluence-table-tree.error.row': 'Unable to load pages.',
  'confluence-table-tree.error.title': 'Well, this is awkward...',
  'confluence-table-tree.friendly-when-created': 'Created',
  'confluence-table-tree.friendly-when-updated': 'Updated',
  'confluence-table-tree.share.copied': 'Copied to clipboard',
  'confluence-table-tree.share.copy-button': 'Copy',
  'confluence-table-tree.share.subtitle': 'Share this link',
  'confluence-table-tree.share.title': 'Share page',
  'confluence-table-tree.share.tooltip': 'Share',
  'confluence-table-tree.view-profile': 'View profile',
};
